export default __webpack_public_path__ + "static/media/Banner_image_Philosophers_stone_small.04382c83.jpg";